/* eslint-disable camelcase */
import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { resetError } from "../../actions/errors";
import PinModal from "../../components/pin";
import {
  fetchDstExtraRule,
  saveDstExtraRule,
} from "../../actions/dst-extra-rules";
import { fetchCountries } from "../../actions/countries";
import { MONTH_NAMES } from "../../constants/month-names";

class DstExtraRuleEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.failedSubmit = this.failedSubmit.bind(this);
  }

  componentWillMount() {
    const { getDstExtraRule, getCountries } = this.props;
    getDstExtraRule();
    getCountries();
  }

  handleChange(e, name) {
    const { value } = e.target;
    this.setState({ [name]: value });
  }

  requestSubmit(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedSubmit() {
    this.setState({
      submitted: false,
    });
  }

  handleSubmit() {
    const { saveDstExtraRuleAction, goToShow, resetErrorAction } = this.props;
    resetErrorAction();
    const {
      start_month,
      start_day,
      end_month,
      end_day,
      year,
      country_id,
    } = this.state;
    const body = {
      start_month,
      start_day,
      end_month,
      end_day,
      year,
      country_id,
    };
    Object.keys(body).forEach(
      (key) => body[key] === undefined && delete body[key],
    );
    const { dstExtraRule } = this.props;
    saveDstExtraRuleAction(dstExtraRule.id, {
      body: JSON.stringify(body),
    }).then(() => goToShow());
  }

  render() {
    const { dstExtraRule, countries } = this.props;
    const {
      start_month,
      start_day,
      end_month,
      end_day,
      year,
      submitted,
    } = this.state;
    if (!dstExtraRule || Object.keys(dstExtraRule).length === 0) {
      return null;
    }
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleSubmit}
            failedSubmit={this.failedSubmit}
          />
        )}
        <Row>
          <Col lg={8}>
            <Card>
              <Form onSubmit={(e) => this.requestSubmit(e)}>
                <CardHeader>
                  <strong>
                    {"Edit DST Extra Rule: "}
                    {dstExtraRule.id}
                  </strong>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Label htmlFor="start_month">DST Start Month</Label>
                    <Input
                      type="select"
                      name="start_month"
                      id="start_month"
                      invalid={submitted && !MONTH_NAMES[start_month]}
                      onChange={(e) => this.handleChange(e, "start_month")}
                      defaultValue={dstExtraRule.start_month}
                      required
                    >
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="start_day">DST Start Day</Label>
                    <Input
                      id="start_day"
                      type="text"
                      placeholder="Enter DST Start Day"
                      invalid={submitted && start_day === ""}
                      onChange={(e) => this.handleChange(e, "start_day")}
                      defaultValue={dstExtraRule.start_day}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_month">DST End Month</Label>
                    <Input
                      type="select"
                      name="end_month"
                      id="end_month"
                      invalid={submitted && !MONTH_NAMES[end_month]}
                      onChange={(e) => this.handleChange(e, "end_month")}
                      defaultValue={dstExtraRule.end_month}
                      required
                    >
                      {MONTH_NAMES.map((month, index) => (
                        <option key={month} value={index}>
                          {month}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="end_day">DST End Day</Label>
                    <Input
                      id="end_day"
                      type="text"
                      placeholder="Enter DST End Day"
                      invalid={submitted && end_day === ""}
                      onChange={(e) => this.handleChange(e, "end_day")}
                      defaultValue={dstExtraRule.end_day}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="year">Year</Label>
                    <Input
                      id="year"
                      type="text"
                      placeholder="Enter Year"
                      invalid={submitted && year === ""}
                      onChange={(e) => this.handleChange(e, "year")}
                      defaultValue={dstExtraRule.year}
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="country_id">Country</Label>
                    <Input
                      type="select"
                      name="country_id"
                      id="country_id"
                      onChange={(e) => this.handleChange(e, "country_id")}
                      defaultValue={dstExtraRule.country_id}
                      required
                    >
                      {countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" size="sm" color="success">
                    Save
                  </Button>{" "}
                  <Button
                    href={`/#/dst-extra-rules/${dstExtraRule.id}`}
                    size="sm"
                    color="danger"
                  >
                    Cancel
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

DstExtraRuleEdit.propTypes = {
  getDstExtraRule: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  goToShow: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
  saveDstExtraRuleAction: PropTypes.func.isRequired,
  dstExtraRule: PropTypes.shape.isRequired,
  countries: PropTypes.arrayOf(PropTypes.object),
};
DstExtraRuleEdit.defaultProps = {
  countries: [],
};

const mapStateToProps = ({ dstExtraRules, countries }) => ({
  dstExtraRule: dstExtraRules.item,
  countries: [...countries.items].sort((a, b) => {
    return a.name.localeCompare(b.name);
  }),
});
const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      getDstExtraRule: () => fetchDstExtraRule(ownProps.match.params.id),
      getCountries: () => fetchCountries(),
      goToShow: () => push(`/dst-extra-rules/${ownProps.match.params.id}`),
      resetErrorAction: () => resetError(),
      saveDstExtraRuleAction: (id, body) => saveDstExtraRule(id, body),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstExtraRuleEdit);
